import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";
import jsBarcode from 'jsbarcode';
import { constants } from '../../types/constants';

import { formatNumber } from "../../services/formatting";
import { IVente, IPdflink } from "../../types/interfaces";
import { getEncModeRegl, getNationality } from "../../services/misc";

// var JsBarcode = require('jsbarcode');

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

const MyDocument: any = Document
const MyPage: any = Page

const ContratDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject, fontSizeFactor, delaiMois }: IPdflink) => {
  if(!data || (data.REMISE && (data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1)))
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const clientsColumns = [{value: "Nom", width: 20}, {value: "Prénom", width: 20}, {value: "CIN", width: 20}, {value: "Tél.", width: 20}, {value: "Tél. 2", width: 20}],
    encaissementsColumns: any[] = [{value: "Effectué par", width: 14}, {value: "Profit de", width: 14}, {value: "Montant", width: 12, formatNumber: true}, {value: "QP", width: 12, formatNumber: true}, {value: "Réf", width: 12.5}, {value: "Date", width: 12.5}, {value: "Banque", width: 11}, {value: "Type", width: 12}];
  
  let canvas = document.createElement("canvas");
  jsBarcode(canvas, `${data.id || "-"}_${data.ID_COM || "-"}${data.ID_COM !== data.authUserId ? `_${data.authUserId || "-"}` : ""}`, {format: "CODE128", height: 60, displayValue: false});
  const barcodePNG = canvas.toDataURL("image/png");
console.log("contrat data", data)
  const typeOfBien = data.TYPE?.toUpperCase().includes("APP") ? constants.APPARTEMENT : data.TYPE?.toUpperCase().includes("MAG") ? constants.MAGASIN : data.TYPE?.toUpperCase().includes("VILLA") ? constants.VILLA : data.TYPE?.toUpperCase().includes("EQUIPEMENT") ? constants.EQUIPEMENT : constants.LOT;
  const writtenPriceM = data.PRIX_M || data.PRIX_M === 0  ? formatNumber(Number(data.PRIX_M) || 0) : null;
  // const writtenPriceM = (data.PRIX_M_CLIENT || data.PRIX_M_CLIENT === 0 || data.PRIX_NET || data.PRIX_NET === 0) && data.SUPERFICIE ? formatNumber((Number((data.PRIX_M_CLIENT || data.PRIX_NET)) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) / Number(data.SUPERFICIE)) : null;
  const writtenPriceClient = data.PRIX_NET || data.PRIX_NET === 0 ? formatNumber(Number(data.PRIX_NET) || 0) : null;
  // const writtenPriceClient = data.PRIX_M_CLIENT || data.PRIX_M_CLIENT === 0 || data.PRIX_NET || data.PRIX_NET === 0 ? formatNumber(Number((data.PRIX_M_CLIENT || data.PRIX_NET)) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) : null;
  const totalEncaissements = data.contrat_encaissements ? data.contrat_encaissements.reduce((prev, b) => prev + (Number(b.PART) || 0), 0) : 0;
  const hasParts = data.contrat_encaissements && data.contrat_encaissements.filter(e => (Number(e.PART) || 0) !== (Number(e.encaissement?.MONTANT || 0) || 0)).length > 0;
  const clients = data.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [];
  const allCivilitesAreKnown = clients.filter(e => !e.CIVILITE).length === 0;
  let names = clients.map(e => `${e.NOM} ${e.PRENOM}`);
  let signsLines: string[][] = [];
  let line: string[] = [];
  for(let i in names){
    line.push(names[i])
    if(line.length === 4 || Number(i) === names.length - 1){
      signsLines.push(line);
      line = [];
    }
  }

  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid';
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING,
      paddingBottom: 90
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 25
    },
    middleLogoContainer1: {
      flex: 5
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    logo: {
      height: "auto",
      flex: 1
    },
    normalText: {
      color: "#000000",
      fontSize: fontSizeFactor || 10,//10
      // fontSize: fontSizeFactor === 1 ? 7 : fontSizeFactor === 2 ? 8 : fontSizeFactor === 3 ? 9 : fontSizeFactor === 4 ? 10 : fontSizeFactor === 5 ? 11 : 10,//10
      fontFamily: 'Open Sans',
      width: "100%",
      flexDirection: "row",
      textAlign: "left"
    },
    tabbedLine: {
      paddingLeft: 20
    },
    group: {
      marginBottom: 20
    },
    groupTitle: {
      justifyContent: "flex-start",
      marginLeft: 2,
      marginBottom: 5
    },
    mainTitle: {
      color: "#000000",
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      fontSize: fontSizeFactor ? fontSizeFactor + 14 : 25,//25
      // fontSize: fontSizeFactor === 1 ? 20 : fontSizeFactor === 2 ? 22 : fontSizeFactor === 3 ? 24 : fontSizeFactor === 4 ? 25 : fontSizeFactor === 5 ? 26 : 25,//25
      textDecoration: "underline",
      justifyContent: "center",
      flexDirection: "row",
      marginBottom: 25
    },
    textMargin: {
      marginBottom: 4
    },
    textMarginPlus: {
      marginBottom: 10
    },
    textMarginPlus2: {
      marginBottom: 20
    },
    textRight: {
      flexDirection: "row",
      justifyContent: "flex-end"
    },
    highlightedText: {
      fontFamily: 'Open Sans',
      fontWeight: 600,
      textDecoration: "underline"
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 10,
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      // paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    }
  });
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        {/* <Text>{fileObject && fileObject.toUpperCase()}</Text> */}
        <Text>{""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      <View fixed={false}>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextTop}}>
                SHEMS AL MADINA
              </Text>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                {data.constantesProjet?.valeur2 ? data.constantesProjet.valeur2.replace(/shems al madina /ig, '').toUpperCase() : "---"}
              </Text>
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>
      
      {hasParts ? <View style={{...styles.mainTitle, marginBottom: 0, textDecoration: "none"}}>
        <Text>*</Text>
      </View> : null}
      
      <View style={styles.mainTitle}>
        <Text>
          CONTRAT DE RESERVATION
        </Text>
      </View>
      
      <View style={styles.group}>
        <View style={{...styles.normalText, ...styles.tabbedLine, ...styles.textMargin}}>
          <Text>Entre les soussignés;</Text>
        </View>
        <View style={{...styles.normalText, ...styles.textMargin}}>
          <Text><Text style={{fontWeight: 600}}>I/</Text>&nbsp;La société dite<Text style={{fontWeight: 600}}>&nbsp;«Société {data.constantesProjet ? data.constantesProjet.valeur : "---"}» S.A</Text>, au capital de {data.constantesProjet ? data.constantesProjet.valeur3 : "---"} dont le siège social est à Lot la Colline Immeuble les Quatre Temps Porte A 5ème étage Sidi Maârouf Casablanca.</Text>
        </View>
        <View style={{...styles.normalText, ...styles.textRight, ...styles.highlightedText}}>
          <Text>Ci-après désigné par le terme</Text>
        </View>
        <View style={{...styles.normalText, ...styles.textRight, ...styles.highlightedText}}>
          <Text>«La société promettante» d’une part</Text>
        </View>
      </View>
      
      <View style={styles.group}>
        <View style={{...styles.normalText, ...styles.textMargin}}>
          <Text style={{fontWeight: 600}}>II/</Text>
        </View>
        {/* <View style={{...styles.normalText, ...styles.textMargin, flexDirection: "column"}}>
          <Text>Mme. RIMI KHADIJA demeurant à AL AZHAR IMM 2 N 98 TRA 5/2 EL BARNOUSSI CASA de nationalité marocaine.</Text>
          <Text>Né à CASABLANCA le 07/10/1966. Titulaire de la carte d'identité nationale numéro BH80751.</Text>
        </View> */}
        {clients.map((e, key) => <View style={{...styles.normalText, ...styles.textMargin, flexDirection: "column"}} key={key}>
          <Text>{allCivilitesAreKnown ? <Text>{e.CIVILITE && e.CIVILITE !== "Ste" ? (e.CIVILITE + ". ") : ""}</Text> : null}<Text style={{fontWeight: 600}}>&nbsp;{`${e.NOM} ${e.PRENOM}`}</Text><Text>&nbsp;demeurant à {e.ADRESSE?.trim() || "-"} de nationalité {/*data.id === 16131 ? "française" : "marocaine"*/}{getNationality(e.NATIONALITE)}.</Text></Text>
          <Text>Né {e.LIEU_NAISS ? `à ${e.LIEU_NAISS} ` : ""}le {e.DATE_NAISS ? moment(e.DATE_NAISS).format('DD/MM/YYYY') : "-"}. Titulaire {e.CIN ? `de la carte d'identité nationale numéro ${e.CIN}` : e.PASSPORT ? `du passeport numéro ${e.PASSPORT}` : "-"}.</Text>
        </View>)}
        <View style={{...styles.normalText, ...styles.textRight, ...styles.highlightedText}}>
          <Text>Ci-après désigné par le terme</Text>
        </View>
        <View style={{...styles.normalText, ...styles.textRight, ...styles.highlightedText}}>
          <Text>« Le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} » d’autre part</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Préambule</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Le réservant envisage de réaliser un projet de lotissement désigné «<Text style={{fontWeight: 600}}>&nbsp;{data.constantesProjet ? data.constantesProjet.valeur2 : "---"}</Text>&nbsp;» situé à {data.constantesProjet ? data.constantesProjet.valeur4 : "---"}.</Text>
          <Text>Ceci exposé, il est convenu et arrêté ce qui suit</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 1 : OBJET</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>La société promettante réserve au{clients.length > 1 ? "x" : ""} réservataire{clients.length > 1 ? "s" : ""}, dans le projet ci-dessus, le bien immobilier ci-après désigné :</Text>
          <Text>Un terrain, consistant en un &nbsp;<Text style={{fontWeight: 600}}>{typeOfBien === constants.APPARTEMENT ? "Appartement" : typeOfBien === constants.MAGASIN ? "Magasin" : "Lot"}</Text>&nbsp;portant le numéro&nbsp;<Text style={{fontWeight: 600}}>{data.NUM_DOSS} {data.TRANCHE}</Text>&nbsp;d’une superficie approximative de&nbsp;<Text style={{fontWeight: 600}}>{data.SUPERFICIE ? (data.SUPERFICIE + "m²") : "-"}</Text>&nbsp;à distraire par voie de morcellement conformément aux lois et dispositions actuellement en vigueur.</Text>
          <Text>Le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} accepte{clients.length > 1 ? "nt" : ""} d’ores et déjà et sans réserve la superficie qui figurera sur le titre foncier parcellaire.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 2 : PROPRIETE - JOUISSANCE</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} {clients.length > 1 ? "seront" : "sera"} propriétaire des biens immobiliers présentement vendus le jour de l’inscription des présentes sur les livres fonciers conformément aux articles 66 et 67 du Dahir du 12 Août 1913 relatif aux immeubles immatriculés, tel que modifié et complété par le Dahir du 25 Di Hijja 1432 (22 Novembre 2011), portant promulgation de la loi 14.07, il en aura la jouissance à partir de ce jour de l’inscription des présentes sur les livres fonciers par la prise de possession réelle à son profit libre de toute occupation ou location quelconque.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 3 : PRIX ET CONDITIONS DE PAIEMENT</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>La réservation objet des présentes est consentie et acceptée {data.PRIX_M ? "moyennant le prix de" : ""}{data.PRIX_M ? <Text style={{fontWeight: 600}}>&nbsp;{data.PRIX_M ? (Number(data.PRIX_M) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceM?.beforeComma || "-"} Dhs)</Text> : null}{data.PRIX_M ? " le mètre carré soit " : ""}la somme totale de {data.PRIX_NET ? Number(data.PRIX_NET).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceClient?.beforeComma || "-"} Dhs).</Text>
          {/* <Text style={{...styles.textMarginPlus}}>La réservation objet des présentes est consentie et acceptée {data.PRIX_M ? "moyennant le prix de" : ""}{data.PRIX_M ? <Text style={{fontWeight: 600}}>&nbsp;{data.PRIX_M ? ((data.PRIX_M_CLIENT || data.PRIX_NET) && data.SUPERFICIE ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) / Number(data.SUPERFICIE) : 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceM?.beforeComma || "-"} Dhs)</Text> : null}{data.PRIX_M ? " le mètre carré soit " : ""}la somme totale de {data.PRIX_M_CLIENT || data.PRIX_NET ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceClient?.beforeComma || "-"} Dhs).</Text> */}
          <Text style={{...styles.textMarginPlus}}>Sur lequel prix de vente de<Text style={{fontWeight: 600}}>&nbsp;{data.PRIX_NET ? (Number(data.PRIX_NET) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceClient?.beforeComma || "-"} Dhs)</Text>.</Text>
          {/* <Text style={{...styles.textMarginPlus}}>Sur lequel prix de vente de<Text style={{fontWeight: 600}}>&nbsp;{data.PRIX_M_CLIENT || data.PRIX_NET ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({writtenPriceClient?.beforeComma || "-"} Dhs)</Text>.</Text> */}
          <Text style={{...styles.textMarginPlus}}>Le{clients.length > 1 ? "s" : ""} «Réservataire{clients.length > 1 ? "s" : ""}» {clients.length > 1 ? "ont" : "a"} payé à titre d’avance la somme de<Text style={{fontWeight: 600}}>&nbsp;{data.contrat_encaissements ? (Number(totalEncaissements) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs ({data.contrat_encaissements ? totalEncaissements?.beforeComma : "-"} Dhs)</Text>&nbsp;comme suit :</Text>
          {/* <Text style={{...styles.textMarginPlus2}}>- CHEQUE N°EFC 8820360 : 20,000.00 Dhs (vingt mille Dhs) Sur BMCE</Text> */}
          {(data.contrat_encaissements || []).map((e, key) => <Text style={{...styles.textMarginPlus2}} key={key}>
            - {getEncModeRegl(e.encaissement?.MODE_REGL)} N° {e.encaissement?.REF_REGLEMENT || "-"} : {(Number(e.encaissement?.MONTANT || 0) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs ({formatNumber(Number(e.encaissement?.MONTANT || 0) || 0).beforeComma} Dhs) {(Number(e.encaissement?.MONTANT || 0) || 0) != (Number(e.PART) || 0) ? ("dont " + (Number(e.PART) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " Dhs (" + formatNumber(Number(e.PART) || 0).beforeComma + " Dhs) ") : ""}sur {e.encaissement ? e.encaissement.bank ? e.encaissement.bank.fullname : e.encaissement.BANQUE : "-"}
          </Text>)}
          <Text>A La société dite «{data.constantesProjet ? data.constantesProjet.valeur : "---"} S.A.» réservante qui le reconnaît et lui en consent bonne et valable quittance d’autant.</Text>
          <Text>DONT QUITTANCE D’AUTANT</Text>
          {((data.PRIX_NET ? (Number(data.PRIX_NET) || 0) : 0) - totalEncaissements) > 0 ? <Text>Le solde, soit la somme de<Text style={{fontWeight: 600}}>&nbsp;{((data.PRIX_NET ? (Number(data.PRIX_NET) || 0) : 0) - totalEncaissements).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs ({formatNumber((data.PRIX_NET ? (Number(data.PRIX_NET) || 0) : 0) - totalEncaissements).beforeComma} Dhs)</Text>&nbsp;sera payée par le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} le jour de la signature de l’acte de vente définitif.</Text> : null}
          {/* {((data.PRIX_M_CLIENT || data.PRIX_NET ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) : 0) - totalEncaissements) > 0 ? <Text>Le solde, soit la somme de<Text style={{fontWeight: 600}}>&nbsp;{((data.PRIX_M_CLIENT || data.PRIX_NET ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) : 0) - totalEncaissements).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs ({formatNumber((data.PRIX_M_CLIENT || data.PRIX_NET ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 1 ? (Number(data.REMISE) || 0) : 0)) : 0) - totalEncaissements).beforeComma} Dhs)</Text>&nbsp;sera payée par le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} le jour de la signature de l’acte de vente définitif.</Text> : null} */}
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 4 : CONDITIONS SUSPENSIVES</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Le présent contrat de réservation est soumis aux conditions suspensives ci-après, expressément acceptées par les parties et devant intervenir au plus tard le jour de la signature de l’acte définitif de vente :</Text>
          <Text>- Éclatement des titres fonciers parcellaires</Text>
          <Text>- Paiement du prix dans sa totalité.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 5 : SUPERFICIE</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>En cas de modification de la superficie après établissement du Titre Foncier parcellaire, le prix de vente sera ajusté à la hausse ou à la baisse sur la base du prix de vente au mètre carré</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 6 : DELAI DE LIVRAISON</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>Le délai prévisionnel d’achèvement des travaux et de mise à disposition de la propriété faisant l’objet du présent contrat est d’environ {delaiMois} mois.</Text>
          <Text style={{...styles.textMarginPlus}}>Le délai d’exécution des travaux, pourra être augmenté en cas de force majeur ou de cause légitime de suspension du délai de livraison. L’époque prévue pour l’achèvement des travaux serait différée d’un temps égal à celui pendant lequel l’événement considéré aurait mis obstacle à la poursuite des travaux.</Text>
          <Text>L’achèvement de l’ensemble des lots composant le programme de lotissement n’étant pas simultané, l’acquéreur devra supporter les inconvénients susceptibles de résulter de l’exécution des travaux d’achèvement et parachèvement du programme ainsi que la réalisation des tranches de l’ensemble du lotissement.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 7 : CLAUSE RESOLUTOIRE</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>En cas de non-paiement du solde du prix de vente soit la deuxième avance ou le solde définitif, 15 jours après l’envoi par lettre recommandée avec accusé de réception {clients.length > 1 ? "aux adresses" : "à l’adresse"} {clients.length > 1 ? "des" : "du"} RESERVATAIRE{clients.length > 1 ? "S" : ""}, telle qu’elle est indiquée ci-dessous, contenant une mise en demeure d’avoir à payer le montant échu en souffrance, le{clients.length > 1 ? "s" : ""} bénéficiaire{clients.length > 1 ? "s" : ""} {clients.length > 1 ? "seront" : "sera"} de plein droit redevable d’une indemnité de retard fixée à 10% du montant dû.</Text>
          <Text style={{...styles.textMarginPlus}}>A défaut du paiement de l’acompte et de l’indemnité de retard suivant l’expiration du délai de 15 jours imparti par la mise en demeure objet du paragraphe ci-dessus, la présente réservation, sera considérée nulle et non avenue, ce que le{clients.length > 1 ? "s" : ""} RESERVATAIRE{clients.length > 1 ? "S" : ""} accepte{clients.length > 1 ? "nt" : ""} sans réserve et ce sans aucune procédure judiciaire.</Text>
          <Text style={{...styles.textMarginPlus}}>Le{clients.length > 1 ? "s" : ""} RESERVATAIRE{clients.length > 1 ? "S" : ""} consent{clients.length > 1 ? "ent" : ""} et accepte{clients.length > 1 ? "nt" : ""} que la société promettante aura droit dans ce cas à une indemnité équivalent à 10% du prix total de la vente indiquée à l’article. L’acompte versé par le{clients.length > 1 ? "s" : ""} RESERVATAIRE{clients.length > 1 ? "S" : ""} sera minoré de cette indemnité et remboursé au{clients.length > 1 ? "x" : ""} RESERVATAIRE{clients.length > 1 ? "S" : ""}.</Text>
          <Text style={{...styles.textMarginPlus}}>Dentre les parties, qu’en cas ou le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} ne {clients.length > 1 ? "répondraient" : "répondrait"} pas dans un délai de 15 jours à compter de la date de réception de la lettre recommandée, le présent contrat de réservation sera considéré comme étant nul et non comme étant nul et non avenu, et sans qu’il soit besoin de remplir aucune formalité ou notification de quelque nature que ce soit, et chacune des parties sera libre de tout engagements réciproques sans qu’il soit besoin d’être constaté par un acte ultérieur. D’autre part le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} autorise{clients.length > 1 ? "nt" : ""} irrévocablement la société promettante à prélever sur le versement effectué DIX POUR CENT (10%) du prix total de la vente, et ce, à titre d’indemnité d’immobilisation, dommages et intérêt en contre partie du préjudice subi. le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} renonçant expressément à toute réclamation ou contestation à ce sujet.</Text>
          <Text>Si le{clients.length > 1 ? "s" : ""} RESERVATAIRE{clients.length > 1 ? "S" : ""} paye{clients.length > 1 ? "nt" : ""} l’avance par chèque, cette réservation est conditionné par l’encaissement de ce chèque par la société promettante, en cas ou le chèque retourne impayé cette réservation devient automatiquement nulle et caduque.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 8 : DESISTEMENT</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Au cas où le{clients.length > 1 ? "s" : ""} bénéficiaire{clients.length > 1 ? "s" : ""} se désiste{clients.length > 1 ? "nt" : ""} de la présente réservation, la société promettante aura droit à une indemnité équivalente à 10% du prix total de la vente indiqué à l’article 3. L’acompte sera remboursé après déduction de cette indemnité.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 9 : CONTRAT DEFINITIF DE VENTE</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Dès l’obtention des titres fonciers parcellaires, la société promettante adressera au{clients.length > 1 ? "x" : ""} réservataire{clients.length > 1 ? "s" : ""} une lettre recommandée avec accusé de réception à l’adresse indiquée ci-dessus, l’invitant à régler le solde définitif du prix de vente et à signer le contrat de vente auprès d’un notaire indiqué par la société promettante.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 10 : DROIT DE SUBSTITUTION</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Il est expressément convenu entre les parties que le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} ne {clients.length > 1 ? "peuvent" : "peut"} céder des droits qu’il{clients.length > 1 ? "s" : ""} {clients.length > 1 ? "détiennent" : "détient"} des présentes, à une tierce personne et avec l’accord exprès et préalable du réservant, moyennant une commission de 5% du prix de vente TTC à verser à ce dernier.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 11 : MODIFICATION</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Les travaux seront réalisés conformément à la conception arrêtée. Cependant la société «<Text style={{fontWeight: 600}}>Société {data.constantesProjet ? data.constantesProjet.valeur : "---"} S.A.</Text>» d’une part se réserve le droit d’effectuer sur ces travaux pendant leur exécution, toutes les modifications qui seraient justifiées par des exigences techniques, juridiques ou commerciales.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 12 : NOTIFICATION</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>Toute notification ou autre communication au titre des présentes sera valablement effectué si elle est adressée par fac-similé et confirmée le jour même par courrier recommandé avec accusé de réception et adressé</Text>
          <Text>Au réservant : au siège de la société.</Text>
          <Text style={{...styles.textMarginPlus}}>Au{clients.length > 1 ? "x" : ""} réservataire{clients.length > 1 ? "s" : ""} : à {clients.length > 1 ? "leurs" : "son"} adresse{clients.length > 1 ? "s" : ""} sus - indiquée{clients.length > 1 ? "s" : ""}.</Text>
          <Text style={{...styles.textMarginPlus}}>Les notifications adressées par lettre recommandée avec accusé de réception seront réputées reçues à la date de réception de la lettre ou à défaut de l’avis de passage du préposé.</Text>
          <Text style={{...styles.textMarginPlus}}>Les notifications effectuées par télécopies confirmées par lettre recommandée avec accusé de réception, seront réputées reçues à la date de réception de la télécopie.</Text>
          <Text>Chacune des parties devra aviser chacune des autres parties de tout changement d’adresse, de numéro de télécopie et de destinataire en respectant la procédure sus- visée.</Text>
        </View>
      </View>
      
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 13 : FRAIS</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text>Tous les frais, droit et honoraires des préurs suites, de quelque nature que ce soit, y compris le droit d’enregistrement et d’inscription à la conservation foncière de l’acte de vente définitif seront à la charge exclusive {clients.length > 1 ? "des" : "du"} bénéficiaire{clients.length > 1 ? "s" : ""}.</Text>
        </View>
      </View>
      
      <View wrap={false}>
      <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 14: INTERDICTION</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>Comme suite et conséquence des présentes, le{clients.length > 1 ? "s" : ""} réservataire{clients.length > 1 ? "s" : ""} déclare{clients.length > 1 ? "nt" : ""} expressément s’interdire pour quelque cause que ce soit, le droit d’intenter toutes actions en justice, faire toute contestation, réclamation ou autre, ainsi que l’inscription de tous droits, pré notations ou inscriptions quelconques sur le titre foncier mètre ou les titres fonciers parcellaires qui seront distraits par voie de morcellement de ce dernier.</Text>
          <Text>A ce propos, il déclare avoir parfaite connaissance des termes et clauses dudit acte et décharger en conséquence le rédacteur des présentes de toutes réclamations ou contestations pouvant surgir ultérieurement entre eux.</Text>
        </View>
      </View>
      
      {data.IDPROJET === 14 && <View style={{...styles.group, marginTop: 20}}>
        <View style={{...styles.normalText, ...styles.highlightedText}}>
          <Text>Article 15: RESPECT FAÇADE-TYPE</Text>
        </View>
        <View style={{...styles.normalText, flexDirection: "column"}}>
          <Text style={{...styles.textMarginPlus}}>Le réservataire doit respecter une façade-type pour son futur immeuble approuvé et prédéfini par la société {data.constantesProjet ? data.constantesProjet.valeur : "---"}.</Text>
          <Text style={{...styles.textMarginPlus}}>Le réservataire s'engage sans réserve et de manière irrévocable à respecter la façade-type approuvée par la société {data.constantesProjet ? data.constantesProjet.valeur : "---"} pour obtenir l'autorisation et réaliser son immeuble.</Text>
          <Text>La réservataire accepte dès maintenant et sans réserve d'intégrer la condition de respecter une façade-type approuvée par la société {data.constantesProjet ? data.constantesProjet.valeur : "---"} dans le contrat définitif de vente.</Text>
        </View>
      </View>}
      
      <View style={{...styles.normalText, ...styles.textRight, ...styles.highlightedText, marginBottom: 80}}>
        <Text>
          DONT ACTE
        </Text>
      </View>
      
      <View style={{...styles.normalText, ...styles.highlightedText}}>
        <Text style={{...styles.tabbedLine}}>
          {clients?.length > 1 ? "LES RESERVATAIRES" : "LE RESERVATAIRE"}
        </Text>
      </View>

      <View style={{...styles.normalText, ...styles.groupTitle, ...styles.highlightedText, ...styles.lastElement, flexDirection: "column"}}>
        {signsLines.map((e, keyE) => <View style={{width: "100%", flexDirection: "row", marginBottom: 50}} key={keyE}>
          {e.map((t, keyT) => <Text style={{width: "25%", textAlign: "center"}} key={keyT}>
            {t}
          </Text>)}
        </View>)}
      </View>
      
      <View style={{...styles.normalText, ...styles.textRight, fontWeight: 600, marginTop: 10, marginBottom: 30}}>
        <Text>
          LA SOCIETE « {data.constantesProjet ? data.constantesProjet.valeur : "---"} S.A.»
        </Text>
      </View>

      </View>
      

      <View style={{...styles.pageCountContainer}} fixed>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
        <View style={{flexDirection: "row", justifyContent: "space-between"}}>
          <Text>{typeOfBien || "-"} N° {data.NUM_DOSS}{data.PROJET !== "CHELLALATE" ? ` TRANCHE ${data.TRANCHE}` : ""}</Text>
          <Image src={barcodePNG} style={{width: 80, height: "auto"}} />
        </View>
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default ContratDocument;
